/* swt-best-sellers.js · Homepage V2 · SWT Product Rail (Best Sellers, New Arrivals, Featured)
   <swt-best-sellers> custom element:
   - ARIA tabs (click, Left/Right/Home/End). Tabs after the first live in a
     <template> and are built the first time they open (no extra images until then).
     With one collection there are no tabs: the single panel just shows.
   - Desktop arrows page the open rail; they disable at each end.
   - The header "See all" link follows the open tab's collection.
   - Theme editor: selecting a tab block opens that tab.
   Phones swipe the rail natively (CSS scroll-snap). Reduced motion: no smooth scroll. */
(function () {
  if (customElements.get('swt-best-sellers')) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class SwtBestSellers extends HTMLElement {
    connectedCallback() {
      if (this.swtBound) return;
      this.swtBound = true;

      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-bs-tab]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-bs-panel]'));
      this.seeAll = this.querySelector('[data-bs-see-all]');
      this.tablist = this.querySelector('[role="tablist"]');
      this.prev = this.querySelector('[data-bs-prev]');
      this.next = this.querySelector('[data-bs-next]');
      this.active = 0;

      var self = this;
      this.tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          self.select(index, true);
        });
      });

      if (this.tablist) {
        this.tablist.addEventListener('keydown', function (event) {
          var last = self.tabs.length - 1;
          var target = null;
          if (event.key === 'ArrowRight') target = self.active >= last ? 0 : self.active + 1;
          else if (event.key === 'ArrowLeft') target = self.active <= 0 ? last : self.active - 1;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = last;
          if (target === null) return;
          event.preventDefault();
          self.select(target, true);
          self.tabs[target].focus();
        });
      }

      if (this.prev) this.prev.addEventListener('click', function () { self.page(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.page(1); });

      this.onResize = function () { self.updateArrows(); };
      window.addEventListener('resize', this.onResize, { passive: true });

      this.onBlockSelect = function (event) {
        if (!self.contains(event.target)) return;
        var index = self.tabs.indexOf(event.target.closest('[data-bs-tab]'));
        if (index > -1) self.select(index, false);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      this.select(0, false);
    }

    disconnectedCallback() {
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(index, fromUser) {
      var panel = this.panels[index];
      if (!panel) return;
      this.active = index;

      this.tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (p, i) {
        p.hidden = i !== index;
      });

      /* Build a tab the first time it opens */
      var tpl = panel.querySelector(':scope > template[data-bs-tpl]');
      if (tpl) {
        panel.appendChild(document.importNode(tpl.content, true));
        tpl.remove();
      }

      if (this.seeAll && panel.dataset.bsUrl) this.seeAll.setAttribute('href', panel.dataset.bsUrl);

      if (fromUser) {
        panel.classList.remove('is-entering');
        void panel.offsetWidth;
        panel.classList.add('is-entering');
      }

      this.rail = panel.querySelector('[data-bs-rail]');
      if (this.rail && !this.rail.dataset.bsBound) {
        var self = this;
        var raf = null;
        this.rail.dataset.bsBound = 'true';
        this.rail.addEventListener('scroll', function () {
          if (raf) window.cancelAnimationFrame(raf);
          raf = window.requestAnimationFrame(function () { self.updateArrows(); });
        }, { passive: true });
      }

      this.keepTabInView(this.tabs[index]);
      this.updateArrows();
    }

    /* Scroll the tab row (never the page) so the open tab is visible on phones */
    keepTabInView(tab) {
      var list = this.tablist;
      if (!list || !tab || list.scrollWidth <= list.clientWidth) return;
      var left = tab.offsetLeft - list.offsetLeft;
      var right = left + tab.offsetWidth;
      var pad = 16;
      if (left < list.scrollLeft + pad) {
        list.scrollTo({ left: Math.max(0, left - pad), behavior: reduceMotion ? 'auto' : 'smooth' });
      } else if (right > list.scrollLeft + list.clientWidth - pad) {
        list.scrollTo({ left: right - list.clientWidth + pad, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    page(direction) {
      var rail = this.rail;
      if (!rail) return;
      var item = rail.querySelector('.swt-bs__item');
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
      var perPage = Math.max(1, Math.floor((rail.clientWidth + gap) / step));
      rail.scrollBy({ left: direction * perPage * step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    updateArrows() {
      var rail = this.rail;
      if (!this.prev || !this.next) return;
      if (!rail) {
        this.prev.disabled = true;
        this.next.disabled = true;
        return;
      }
      var max = rail.scrollWidth - rail.clientWidth;
      this.prev.disabled = rail.scrollLeft <= 2;
      this.next.disabled = rail.scrollLeft >= max - 2;
    }
  }

  customElements.define('swt-best-sellers', SwtBestSellers);
})();
